import Delta from "quill-delta";
import { markdownToDelta } from "util/markdownToDelta";

// Values saved before Delta are plain text, or markdown where hasLegacyMarkdown
export const parseRichText = (
  value?: string | null,
  hasLegacyMarkdown = false
): Delta => {
  if (!value) return new Delta();

  const parseLegacy = () =>
    hasLegacyMarkdown ? markdownToDelta(value) : new Delta().insert(value);

  try {
    const parsed = JSON.parse(value);
    if (Array.isArray(parsed?.ops)) return new Delta(parsed.ops);
  } catch {
    return parseLegacy();
  }

  return parseLegacy();
};

export const deltaToPlainText = (value?: string | null): string =>
  parseRichText(value)
    .ops.map((op) => (typeof op.insert === "string" ? op.insert : ""))
    .join("")
    .trim();
